import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { defaultLanguage, languages } from '../consts';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private router = inject(Router);
  private storage = inject(StorageService);
  private platformId = inject<string>(PLATFORM_ID);
  current: BehaviorSubject<string> = new BehaviorSubject(defaultLanguage);

  constructor() {
    if (isPlatformServer(this.platformId)) return;
    this.loadLanguage();
    this.router.events.subscribe(event => {
      if (!(event instanceof NavigationEnd)) return;
      this.loadLanguage();
    });
  }

  /**
   * @returns the current language
   */
  loadLanguage(): void {
    const language = this.getLanguageInternal();
    if (this.current.getValue() !== language) {
      if (isPlatformBrowser(this.platformId)) this.storage.set('_language', language);
      this.current.next(language);
    }
  }

  private getLanguageInternal(): string {
    return defaultLanguage;
    // if (!this.featureFlags.get('translations')) return defaultLanguage;
    const urlLanguage = <string>location.pathname.split('/')[1];
    if (languages.includes(urlLanguage)) return urlLanguage;

    if (isPlatformBrowser(this.platformId)) {
      const localStorageLanguage = <string>this.storage.get('_language');
      if (languages.includes(localStorageLanguage)) return localStorageLanguage;
      const browserLanguage = <string>navigator.language.substring(0, 2);
      if (languages.includes(browserLanguage)) return browserLanguage;
    }

    return defaultLanguage;
  }
}
